import React, { useEffect, useRef, useState, useContext } from 'react';

import { Accordion, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';

import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Swal from 'sweetalert2';

import useShopeRegistration from '../../../hooks/useShopRegistration';

import { Box, Typography, Stack, Grid, Divider, Button, Card, CardContent } from '@mui/material';
import StarIcon from '../../../adminAssets/images/subscription/material-symbols_star.svg';
import CrownIcon from '../../../adminAssets/images/subscription/material-symbols_crown.svg';
import FirstClassWebImg from '../../../adminAssets/images/subscription/firstclass_web.png';
import DomainIcon from '../../../adminAssets/images/subscription/firstclass_icon/gridicons_domains.svg';
import ResponsiveIcon from '../../../adminAssets/images/subscription/firstclass_icon/gg_ui-kit.svg';
import SeoIcon from '../../../adminAssets/images/subscription/firstclass_icon/ri_seo-line.svg';
import WhatsappIcon from '../../../adminAssets/images/subscription/firstclass_icon/ic_outline-whatsapp.svg';
import HostingIcon from '../../../adminAssets/images/subscription/firstclass_icon/carbon_ibm-cloud-direct-link-1-dedicated-hosting.svg';
import LandingIcon from '../../../adminAssets/images/subscription/firstclass_features_icon/material-symbols_home-pin-outline.svg';
import ProductIcon from '../../../adminAssets/images/subscription/firstclass_features_icon/ant-design_product-outlined.svg';
import ContactIcon from '../../../adminAssets/images/subscription/firstclass_features_icon/mdi_contact-outline.svg';
import WhatsappIntIcon from '../../../adminAssets/images/subscription/firstclass_features_icon/ic_outline-whatsapp.svg';
import CheckOutIcon from '../../../adminAssets/images/subscription/firstclass_features_icon/material-symbols_shopping-cart-outline.svg';
import CheckedIcon from '../../../adminAssets/images/subscription/checked.svg';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useOnboarding } from '../../../context/AdminSellerRegistrationOB';
import { SubmitHandler, useForm } from 'react-hook-form';
import useBank from '../../../hooks/useBank';
import useSellerPackage from '../../../hooks/useSellerSelectionPackage';

import { generateThousandSeparator } from '../../../utils/string-manipulator';
import { useAppConfig } from '../../../context/AppConfigContext';
import useSubscriptionPackage from '../../../hooks/useSubscriptionPackage';
import parse from 'html-react-parser';

export const PackageTypeEnum = Object.freeze({
    Monthly: 0,
    Yearly: 1
});

export const PaymentType = Object.freeze({
    BankTransfer: 0,
    QRCode: 1
});

const schema = yup
    .object({
        packageId: yup.string().required(),
        bankTransferId: yup.string().required(),
        bankaccountname: yup.string(),
        bankaccountnumber: yup.string()
    })
    .required();

const CompanySellerSubsPayment_Summary = () => {
    const navigate = useNavigate();

    const { fetchActiveBank, data: activeBank } = useBank();
    const { fetchSubscriptionPackage, data: subscriptionPackages } = useSubscriptionPackage();
    const { fetchPackage, data: sellerPackages } = useSellerPackage();
    const [activeKey, setActiveKey] = useState('0');
    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedBankValue, setSelectedBankValue] = useState(null);
    const { saveStep, saveQris, data, qris, clear } = useOnboarding();

    const { currency } = useAppConfig();

    //console.log(sellerPackages);
    const { sentCustomerShopCreate: subscribeShop } = useShopeRegistration();

    const [isYearly, setIsYearly] = useState(false);

    const DatatoSent = {
        bussinesstype: data.bussinesstype ?? '',
        ownerName: data.ownerName ?? '',
        citizenID: data.citizenID ?? '',
        agreement: data.agreement ?? false,
        email: data.email ?? '',
        shopName: data.shopName ?? '',
        phone: data.phone ?? '',
        phoneCC: data.phone ?? '+62'
    };

    // const StaticProductCategory = [
    //     {
    //         isActive: true,
    //         id: 'f37f7e82-b3a3-49b8-9485-dd2ac2ab11c1',
    //         name: 'Economy Plan',
    //         description: 'Newly Or Personal start up bussiness',
    //         descriptionList: [
    //             'Up to 30 days listing product display',
    //             'Up to 1 username per 1 shop',
    //             'Up to 100 products listing per shops',
    //             'Bussniness Location limit to Local country only',
    //             'Shop advertise up to local community only'
    //         ],

    //         totalUser: 0,
    //         // SG
    //         // monthlyPrice: 10,
    //         // yearlyPrice: 10 * 12,
    //         // ID
    //         monthlyPrice: 99900,
    //         yearlyPrice: 99900 * 12,
    //         discountedMonthlyPrice: 3,
    //         discountedYearlyPrice: 45,
    //         subscriptionType: 1,
    //         image: null,
    //         color: null,
    //         index: 1,
    //         canDowngrade: false
    //     },
    //     {
    //         isActive: false,
    //         id: 'f37f7e82-b3a3-49b8-9485-dd2ac2ab11c2',
    //         name: 'Business Plan',
    //         description: 'For seller who wants to seriously expand their business',
    //         descriptionList: [
    //             'Up to 30 days listing product listing display',
    //             'Up to 1 username in multiple devices',
    //             'Up to 300 products listing per shops',
    //             'Bussniness Location limit up to ASEAN customer',
    //             'Shop advertise up to up to ASEAN seller & customer'
    //         ],
    //         totalUser: 0,
    //         // SG
    //         // monthlyPrice: 25,
    //         // yearlyPrice: 25 * 12,
    //         // ID
    //         monthlyPrice: 259900,
    //         yearlyPrice: 259900 * 12,
    //         discountedMonthlyPrice: 15,
    //         discountedYearlyPrice: 180,
    //         subscriptionType: 2,
    //         image: null,
    //         color: null,
    //         index: 2,
    //         canDowngrade: false
    //     },
    //     {
    //         isActive: false,
    //         id: 'f37f7e82-b3a3-49b8-9485-dd2ac2ab11c3',
    //         name: 'First Class',
    //         description: 'For seller who wants all the benefits and premium services',
    //         descriptionList: [
    //             'Up to 30 days listing product listing display',
    //             'Up to 1 username in multiple devices',
    //             'Up to 1K+ items products listing',
    //             'Bussniness Location limit up to ASEAN customer',
    //             'Shop advertise up to up to ASEAN seller & customer',
    //             'Optional for Website development up to 5 basic pages (minimum 2 years contract plan)',
    //             'Optional dedicated managing on TikTok/IG/FB (minimum 1 year contract plan)'
    //         ],
    //         totalUser: 0,
    //         // SG
    //         // monthlyPrice: 50,
    //         // yearlyPrice: 50 * 12,
    //         // ID
    //         monthlyPrice: 599900,
    //         yearlyPrice: 599900 * 12,
    //         discountedMonthlyPrice: 40,
    //         discountedYearlyPrice: 40 * 12,
    //         subscriptionType: 3,
    //         image: null,
    //         color: null,
    //         index: 3,
    //         canDowngrade: false
    //     }
    // ];

    const handleRadioClick = (e, value) => {
        e.stopPropagation(); // Crucial: Prevents the click from reaching the accordion toggle
        console.log(value);
        setSelectedValue(value);

        //console.log(value)
    };

    const prevData = data;

    const handleBankClick = (e, value) => {
        setSelectedBankValue(value);
    };

    const inputcheckClass = (field) => `form-check mb-0 custom-circular-checkbox ${errors[field] ? 'is-invalid' : ''}`;

    // This function handles the accordion toggle (optional, can be managed by activeKey alone)
    const handleAccordionToggle = (eventKey) => {
        setActiveKey(eventKey);
    };

    const accordionItems = [
        { eventKey: '0', header: 'Item #1', body: 'Content for item 1.' },
        {
            eventKey: '1',
            header: 'Item #2',
            body: 'Content for item 2.'
        },
        { eventKey: '2', header: 'Item #3', body: 'Content for item 3.' }
    ];

    const onSubmit = async (formData) => {
        // await api.post("/register/complete", data);
        // clear();
        // navigate("/registration-seller-completed");
        // console.log("FORM DATA:", formData);

        // console.log("..data: ");
        // console.log(...data);
        const payload = {
            ...prevData, // onboarding data
            // formData,
            userId: JSON.parse(localStorage.getItem('user')).id,
            packageId: formData.packageId,
            bankTransferId: formData.bankTransferId,
            shippingLatLong:
                data.shippinglatitude !== undefined && data.shippinglongitude !== undefined
                    ? data.shippinglatitude + ',' + data.shippinglongitude
                    : '',
            businessLatLong: data.latitude !== undefined && data.longitude !== undefined ? data.latitude + ',' + data.longitude : '',
            bankAccountName: formData.bankaccountname,
            bankAccountNumber: formData.bankaccountnumber,
            yearEstablish: data.yearEstablished ?? new Date().getFullYear(),
            packageType: isYearly ? PackageTypeEnum.Yearly : PackageTypeEnum.Monthly,
            productOrigin: data.productOrigin?.label,
            flag: data.productOrigin?.value
        };

        try {
            const result = await subscribeShop(payload);
            console.log(result);
            // Swal.fire({
            //     title: 'Success',
            //     text: 'Register successfully',
            //     icon: 'success'
            // });
            if (result == 'success!') {
                console.log(result);
                saveQris({
                    qrisImage: selectedBankValue.qris,
                    bankTransferId: formData.bankTransferId
                });

                console.log(qris);
            }

            saveQris({
                qrisImage: selectedBankValue.qris,
                bankTransferId: formData.bankTransferId
            });

            navigate('/admin/seller-subscription-completed');
        } catch (err) {
            //console.log(err);
            Swal.fire({
                title: 'Error',
                text: err,
                icon: 'error'
            });
        }
    };

    const readUserData = () => {
        if (localStorage.getItem('user') == null) {
            navigate('/login');
        }
    };

    useEffect(() => {
        readUserData();
        fetchPackage();
        fetchActiveBank();
        fetchSubscriptionPackage();
    }, []);

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            bankaccountname: data.bankaccountname ?? '',
            bankaccountnumber: data.bankaccountnumber ?? ''
        }
    });

    const agreementValue = watch('agreement');

    return (
        <div className="payment_summary text_quicksand">
            <div className="container">
                <div className="card mb-40">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 col-md-6 mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Shop Name</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.businessName ?? data.name}</span>
                                </div>
                            </div>
                            <div className="col-12 col-md-6  mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Email</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.email}</span>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Bussiness Type</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">
                                        {data.businessType === 0 ? 'Personal' : 'Company'}
                                    </span>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Phone Number</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.phone}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="title text_quicksand fw-bold text-32 text-black d-flex justify-content-between align-items-center mb-40">
                    <span>Plan</span>

                    <Box
                        onClick={() => {
                            const newIsYearly = !isYearly;
                            setIsYearly(newIsYearly);

                            if (!newIsYearly && selectedValue) {
                                const selectedPkg = subscriptionPackages.find((p) => p.id === selectedValue.id);
                                const isFirstClass =
                                    selectedPkg?.subscriptionType === 3 || selectedPkg?.name?.toLowerCase()?.includes('first');
                                if (isFirstClass) {
                                    setValue('packageId', '', { shouldValidate: true });
                                    setSelectedValue(null);
                                }
                            }
                        }}
                        sx={{
                            position: 'relative',
                            width: 250,
                            height: 36,
                            backgroundColor: '#E8E8E8',
                            borderRadius: '36px',
                            cursor: 'pointer',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                width: '124px',
                                height: '100%',
                                backgroundColor: '#970A02',
                                borderRadius: '36px',
                                left: isYearly ? '126px' : '0',
                                transition: '0.3s'
                            }
                        }}
                    >
                        <Box
                            sx={{
                                position: 'relative',
                                zIndex: 1,
                                display: 'flex',
                                height: '100%',
                                alignItems: 'center',
                                textAlign: 'center',
                                fontWeight: 500
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    color: !isYearly ? '#fff' : '#A1A1A1',
                                    fontFamily: 'Quicksand, sans-serif',
                                    fontSize: '16px'
                                }}
                            >
                                Monthly
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    color: isYearly ? '#fff' : '#A1A1A1',
                                    fontFamily: 'Quicksand, sans-serif',
                                    fontSize: '16px'
                                }}
                            >
                                Yearly
                            </Box>
                        </Box>
                    </Box>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box sx={{ margin: '40px 0 70px' }}>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'stretch' }}>
                            {subscriptionPackages.map((item, index) => {
                                const isFirstClass = item.subscriptionType === 3 || item.name?.toLowerCase()?.includes('first');
                                const isBusiness = item.subscriptionType === 2 || item.name?.toLowerCase()?.includes('business');
                                const isSelected = selectedValue?.index === String(index);
                                const isDisabled = !isYearly && (item.id === 'f37f7e82-b3a3-49b8-9485-dd2ac2ab11c3' || isFirstClass);

                                return (
                                    <Box
                                        sx={{
                                            flex: isFirstClass ? '2 1 500px' : '1 1 250px',
                                            minWidth: 0,
                                            display: 'flex',
                                            flexDirection: 'column',
                                            opacity: isDisabled ? 0.5 : 1,
                                            pointerEvents: isDisabled ? 'none' : 'auto'
                                        }}
                                        key={index}
                                        onClick={() => {
                                            if (isDisabled) return;
                                            setValue('packageId', String(item.id), { shouldValidate: true });
                                            setSelectedValue({
                                                index: String(index),
                                                id: item.id,
                                                price: isYearly ? item.yearlyPrice : item.monthlyPrice,
                                                packageName: item.name
                                            });
                                        }}
                                        style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                                    >
                                        <Form.Check
                                            type="radio"
                                            {...register('packageId')}
                                            value={String(item.id)}
                                            checked={isSelected}
                                            style={{ display: 'none' }}
                                            onChange={() => {}}
                                        />
                                        {isFirstClass ? (
                                            <Box
                                                sx={{
                                                    border: isSelected ? '3px solid #990A02' : '1px solid #E6E6E6',
                                                    borderRadius: '16px',
                                                    overflow: 'visible',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    height: '100%',
                                                    position: 'relative'
                                                }}
                                            >
                                                {isSelected && (
                                                    <Box
                                                        sx={{
                                                            position: 'absolute',
                                                            width: '138px',
                                                            height: '37px',
                                                            color: '#fff',
                                                            backgroundColor: '#990A02',
                                                            borderRadius: '25px',
                                                            top: '-20px',
                                                            left: '50%',
                                                            transform: 'translateX(-50%)',
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Quicksand, sans-serif',
                                                                textAlign: 'center',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                padding: '9px 0'
                                                            }}
                                                        >
                                                            Selected Plan
                                                        </Typography>
                                                    </Box>
                                                )}
                                                <Box
                                                    sx={{
                                                        background: 'linear-gradient(260.87deg, #FF4355 2.33%, #970A02 98.58%)',
                                                        color: 'white',
                                                        padding: '40px 30px 20px',
                                                        textAlign: 'center',
                                                        borderTopLeftRadius: isSelected ? '13px' : '15px',
                                                        borderTopRightRadius: isSelected ? '13px' : '15px'
                                                    }}
                                                >
                                                    <Stack direction="row" justifyContent="center" alignItems="center" gap={1} mb={1}>
                                                        <img src={CrownIcon} alt="Crown" width="20" />
                                                        <Typography
                                                            sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '18px', fontWeight: '700' }}
                                                        >
                                                            {item.name}
                                                        </Typography>
                                                    </Stack>
                                                    <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '12px', mb: 2 }}>
                                                        All the best feature + Personal Website
                                                    </Typography>

                                                    <Stack
                                                        direction="row"
                                                        justifyContent="center"
                                                        gap="5px"
                                                        alignItems="end"
                                                        sx={{ flexWrap: 'wrap' }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Quicksand, san-serif',
                                                                fontSize: '20px',
                                                                fontWeight: '700',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            {currency}
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Quicksand, san-serif',
                                                                fontSize: '20px',
                                                                fontWeight: '700',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            {isYearly
                                                                ? generateThousandSeparator(item.yearlyPrice.toString())
                                                                : generateThousandSeparator(item.monthlyPrice.toString())}
                                                            .00
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Quicksand, san-serif',
                                                                fontSize: '16px',
                                                                fontWeight: '700',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            {isYearly ? '/ Yr' : '/ Mo'}
                                                        </Typography>
                                                    </Stack>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        padding: '30px',
                                                        flexGrow: 1,
                                                        backgroundColor: 'white',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        minWidth: 0
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontFamily: 'Quicksand, san-serif',
                                                            fontWeight: '700',
                                                            fontSize: '14px',
                                                            mb: 2
                                                        }}
                                                    >
                                                        All feature in Business, and :
                                                    </Typography>
                                                    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                                                        <Grid item xs={12} md={6}>
                                                            <Box
                                                                sx={{
                                                                    wordBreak: 'normal',
                                                                    overflowWrap: 'break-word',
                                                                    '& ul': { listStyleType: 'none', pl: 0, m: 0 },
                                                                    '& li': {
                                                                        position: 'relative',
                                                                        paddingLeft: '24px',
                                                                        mb: 1,
                                                                        fontFamily: 'Quicksand, san-serif',
                                                                        fontSize: '14px',
                                                                        color: '#666',
                                                                        '&::before': {
                                                                            content: '""',
                                                                            position: 'absolute',
                                                                            left: 0,
                                                                            top: '2px',
                                                                            width: '16px',
                                                                            height: '16px',
                                                                            backgroundImage: `url(${CheckedIcon})`,
                                                                            backgroundSize: 'contain',
                                                                            backgroundRepeat: 'no-repeat'
                                                                        }
                                                                    }
                                                                }}
                                                            >
                                                                {parse(item.description ? item.description.replace(/&nbsp;/g, ' ') : '')}
                                                            </Box>
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={12}
                                                            md={6}
                                                            sx={{
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <img
                                                                src={FirstClassWebImg}
                                                                alt="web"
                                                                style={{ maxWidth: '100%', maxHeight: '200px', objectFit: 'contain' }}
                                                            />
                                                        </Grid>
                                                    </Grid>

                                                    <Button
                                                        type="button"
                                                        sx={{
                                                            fontFamily: 'Quicksand, san-serif',
                                                            border: '1px solid #970A02',
                                                            color: isSelected ? '#fff' : '#970A02',
                                                            backgroundColor: isSelected ? '#970A02' : '#fff',
                                                            borderRadius: '28px',
                                                            fontWeight: '500',
                                                            fontSize: '14px',
                                                            padding: '8px 20px',
                                                            width: '100%',
                                                            maxWidth: '300px',
                                                            margin: '20px auto 0',
                                                            display: 'block',
                                                            '&:hover': {
                                                                backgroundColor: isSelected ? '#750802' : '#f9f9f9'
                                                            }
                                                        }}
                                                    >
                                                        {isSelected ? 'Selected Plan' : 'Select Plan'}
                                                    </Button>
                                                </Box>
                                            </Box>
                                        ) : (
                                            <Box
                                                sx={{
                                                    border: isSelected
                                                        ? '3px solid #990A02'
                                                        : isBusiness
                                                          ? '2px solid #970A02'
                                                          : '1px solid #E6E6E6',
                                                    borderRadius: '16px',
                                                    position: 'relative',
                                                    padding: '50px 30px 20px',
                                                    height: '100%',
                                                    display: 'flex',
                                                    flexDirection: 'column'
                                                }}
                                            >
                                                {isSelected && (
                                                    <Box
                                                        sx={{
                                                            position: 'absolute',
                                                            width: '138px',
                                                            height: '37px',
                                                            color: '#fff',
                                                            backgroundColor: '#990A02',
                                                            borderRadius: '25px',
                                                            top: '-20px',
                                                            left: '50%',
                                                            transform: 'translateX(-50%)'
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Quicksand, sans-serif',
                                                                textAlign: 'center',
                                                                fontSize: '14px',
                                                                fontWeight: '600',
                                                                padding: '9px 0'
                                                            }}
                                                        >
                                                            Selected Plan
                                                        </Typography>
                                                    </Box>
                                                )}
                                                {isBusiness && !isSelected && (
                                                    <Box
                                                        sx={{
                                                            position: 'absolute',
                                                            top: '-15px',
                                                            left: '50%',
                                                            transform: 'translateX(-50%)',
                                                            backgroundColor: '#970A02',
                                                            color: 'white',
                                                            borderRadius: '20px',
                                                            padding: '5px 20px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '5px',
                                                            whiteSpace: 'nowrap'
                                                        }}
                                                    >
                                                        <img src={StarIcon} alt="Star" width="16" />
                                                        <Typography
                                                            sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '12px', fontWeight: '600' }}
                                                        >
                                                            Best Value
                                                        </Typography>
                                                    </Box>
                                                )}

                                                <Box
                                                    sx={{
                                                        maxWidth: '330px',
                                                        margin: '0 auto',
                                                        width: '100%',
                                                        minWidth: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        flexGrow: 1
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontFamily: 'Quicksand, san-serif',
                                                            fontSize: '18px',
                                                            fontWeight: '700',
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        {item.name}
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontFamily: 'Quicksand, san-serif',
                                                            fontSize: '12px',
                                                            textAlign: 'center',
                                                            color: '#666',
                                                            mb: '20px'
                                                        }}
                                                    >
                                                        {isBusiness ? 'Complete Feature for bigger business' : 'For Developed Business'}
                                                    </Typography>

                                                    <Stack
                                                        direction="row"
                                                        justifyContent="center"
                                                        gap="5px"
                                                        alignItems="end"
                                                        sx={{ margin: '0 auto', color: '#000000', flexWrap: 'wrap' }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Quicksand, san-serif',
                                                                fontSize: '20px',
                                                                fontWeight: '700',
                                                                textAlign: 'center',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            {currency}
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Quicksand, san-serif',
                                                                fontSize: '20px',
                                                                fontWeight: '700',
                                                                textAlign: 'center',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            {isYearly
                                                                ? generateThousandSeparator(item.yearlyPrice.toString())
                                                                : generateThousandSeparator(item.monthlyPrice.toString())}
                                                            .00
                                                        </Typography>
                                                        <Typography
                                                            sx={{
                                                                fontFamily: 'Quicksand, san-serif',
                                                                fontSize: '16px',
                                                                fontWeight: '700',
                                                                textAlign: 'center',
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            {isYearly ? '/ Yr' : '/ Mo'}
                                                        </Typography>
                                                    </Stack>
                                                    <Divider sx={{ margin: '20px 0' }} />

                                                    <Box
                                                        sx={{
                                                            wordBreak: 'normal',
                                                            overflowWrap: 'break-word',
                                                            flexGrow: 1,
                                                            '& ul': { listStyleType: 'none', pl: 0, m: 0 },
                                                            '& li': {
                                                                position: 'relative',
                                                                paddingLeft: '24px',
                                                                mb: 1,
                                                                fontFamily: 'Quicksand, san-serif',
                                                                fontSize: '14px',
                                                                color: '#666',
                                                                '&::before': {
                                                                    content: '""',
                                                                    position: 'absolute',
                                                                    left: 0,
                                                                    top: '2px',
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    backgroundImage: `url(${CheckedIcon})`,
                                                                    backgroundSize: 'contain',
                                                                    backgroundRepeat: 'no-repeat'
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {parse(item.description ? item.description.replace(/&nbsp;/g, ' ') : '')}
                                                    </Box>

                                                    <Button
                                                        type="button"
                                                        sx={{
                                                            fontFamily: 'Quicksand, san-serif',
                                                            border: `1px solid ${!isYearly && item.subscriptionType === 3 ? '#ccc' : '#970A02'}`,
                                                            color: isSelected ? '#fff' : '#970A02',
                                                            backgroundColor: isSelected ? '#970A02' : '#fff',
                                                            borderRadius: '28px',
                                                            fontWeight: '500',
                                                            fontSize: '12px',
                                                            padding: '8px 20px',
                                                            width: '100%',
                                                            maxWidth: '200px',
                                                            margin: '20px auto 0',
                                                            display: 'block',
                                                            '&:hover': {
                                                                backgroundColor: isSelected ? '#750802' : '#f9f9f9'
                                                            }
                                                        }}
                                                    >
                                                        {isSelected ? 'Selected Plan' : 'Select Plan'}
                                                    </Button>
                                                </Box>
                                            </Box>
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>

                        {/* Your Personal Website Section */}
                        <Card sx={{ border: '1px solid #E6E6E6', borderRadius: '16px', mt: '40px' }}>
                            <CardContent sx={{ p: { xs: 2, md: 4 } }}>
                                <Grid container spacing={4} alignItems="center">
                                    {/* Left */}
                                    <Grid item xs={12} md={3}>
                                        <Stack direction="row" alignItems="center" gap={1} mb={2}>
                                            <i className="ph-duotone ph-desktop text-20" style={{ color: '#970A02' }}></i>
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Quicksand, san-serif',
                                                    fontSize: '18px',
                                                    fontWeight: '700',
                                                    color: '#970A02'
                                                }}
                                            >
                                                Your Personal Website
                                            </Typography>
                                        </Stack>
                                        <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px', color: '#666', mb: 4 }}>
                                            Includes with 5 minimum static pages : Home, About, Product catalogue, Contact, Testimonial,
                                            etc.
                                        </Typography>
                                        <Stack spacing={2} mb={4}>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={DomainIcon} alt="domain" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    Private Domain
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={ResponsiveIcon} alt="responsive" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    Responsive Design
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={SeoIcon} alt="seo" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    SEO Friendly
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={WhatsappIcon} alt="wa" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    Whatsapp & Other Contacts
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={HostingIcon} alt="hosting" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    Safe & Fast Hosting
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                        <Button
                                            variant="contained"
                                            sx={{
                                                backgroundColor: '#970A02',
                                                color: 'white',
                                                borderRadius: '25px',
                                                padding: '10px 20px',
                                                fontFamily: 'Quicksand, san-serif',
                                                textTransform: 'none',
                                                '&:hover': { backgroundColor: '#750802' }
                                            }}
                                        >
                                            Contact Us For More Info
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            href="https://dev.iwant-asia.com"
                                            target="_blank"
                                            sx={{
                                                borderColor: '#970A02',
                                                color: '#970A02',
                                                borderRadius: '25px',
                                                padding: '10px 20px',
                                                fontFamily: 'Quicksand, san-serif',
                                                textTransform: 'none',
                                                '&:hover': { borderColor: '#750802', backgroundColor: 'rgba(151, 10, 2, 0.04)' }
                                            }}
                                        >
                                            Web Preview
                                        </Button>
                                    </Grid>

                                    {/* Middle Image */}
                                    <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                                        <img src={FirstClassWebImg} alt="first class web" style={{ maxWidth: '100%', height: 'auto' }} />
                                    </Grid>

                                    {/* Right */}
                                    <Grid item xs={12} md={3}>
                                        <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px', fontWeight: '700', mb: 3 }}>
                                            Features :
                                        </Typography>
                                        <Stack spacing={2}>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={LandingIcon} alt="landing" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    Landing Page
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={ProductIcon} alt="product" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    Product Catalogue
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={ContactIcon} alt="contact" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    Contact Us page
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={WhatsappIntIcon} alt="wa int" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    Whatsapp Integrated
                                                </Typography>
                                            </Stack>
                                            <Stack direction="row" alignItems="center" gap={2}>
                                                <img src={CheckOutIcon} alt="checkout" width="20" />
                                                <Typography sx={{ fontFamily: 'Quicksand, san-serif', fontSize: '14px' }}>
                                                    Check Out
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Box>

                    <div className="card mb-40">
                        <div className="card-body">
                            <div className="mb-20">
                                <span className="text-20 fw-bold">Payment Details</span>
                            </div>
                            <div>
                                <div className="d-flex justify-content-between mb-10 text-16">
                                    <span className="">
                                        Order Subtotal {selectedValue ? <strong>{selectedValue.packageName + ' Plan'}</strong> : ''}
                                    </span>
                                    <span className="fw-bold">Qty : {isYearly ? 12 : 1} months</span>
                                    <span>
                                        {currency}{' '}
                                        {selectedValue
                                            ? (() => {
                                                  const pkg = subscriptionPackages.find((p) => p.id === selectedValue.id);
                                                  const price = pkg ? (isYearly ? pkg.yearlyPrice : pkg.monthlyPrice) : 0;
                                                  return generateThousandSeparator(price.toFixed(2));
                                              })()
                                            : '0.00'}
                                    </span>
                                </div>
                                {/* <div className="d-flex justify-content-between  mb-10 text-16 d-none">
                                    <span className="">Delivery Fee</span>
                                    <span>$1000.00</span>
                                </div>
                                <div className="d-flex justify-content-between mb-10 text-16  d-none">
                                    <span className="">Delivery Discount</span>
                                    <span className="text-danger">-$5.00</span>
                                </div> */}
                            </div>
                            <hr />
                            <div className="mb-20">
                                <div className="d-flex justify-content-between mb-10 text-16 fw-bold">
                                    <span className="">Order Subtotal : </span>
                                    <span>
                                        {currency}{' '}
                                        {selectedValue
                                            ? (() => {
                                                  const pkg = subscriptionPackages.find((p) => p.id === selectedValue.id);
                                                  const price = pkg ? (isYearly ? pkg.yearlyPrice : pkg.monthlyPrice) : 0;
                                                  return generateThousandSeparator(price.toFixed(2));
                                              })()
                                            : '0.00'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="payment-method mb-80">
                        <div className="text-20 fw-bold mb-40" style={{ color: '#1A1A1A' }}>
                            <span>Payment Method</span>
                        </div>
                        <Tab.Container id="left-tabs-example" className="d-none" defaultActiveKey="home">
                            <Nav variant="pills" className="d-flex align-items-center gap-20 mb-40">
                                <Nav.Item>
                                    <Nav.Link eventKey="banktransfer">Bank Transfer</Nav.Link>
                                </Nav.Item>
                                {/* <Nav.Item>
                                    <Nav.Link eventKey="creditcard">Credit Card</Nav.Link>
                                </Nav.Item>  */}
                                {activeBank.filter((bank) => bank.type === PaymentType.QRCode).length > 0 && (
                                    <Nav.Item className="">
                                        <Nav.Link eventKey="qrcode">QR Code</Nav.Link>
                                    </Nav.Item>
                                )}
                            </Nav>
                            <Tab.Content>
                                {['banktransfer', 'creditcard', 'qrcode'].map((item) => {
                                    const _filteredBanks = activeBank.filter((bank) => {
                                        if (item === 'banktransfer') {
                                            return bank.type === PaymentType.BankTransfer;
                                        } else if (item === 'qrcode') {
                                            return bank.type === PaymentType.QRCode;
                                        }
                                        return false;
                                    });

                                    return (
                                        <Tab.Pane eventKey={item}>
                                            <div className="">
                                                <div>
                                                    {_filteredBanks.map((bank, index) => (
                                                        <label className="d-flex align-items-center gap-24 mb-32">
                                                            <span className="position-relative">
                                                                <Form.Check
                                                                    type="radio"
                                                                    id={`bankSelection-` + String(bank + 3)}
                                                                    // name="banks"
                                                                    {...register('bankTransferId')}
                                                                    value={bank.id}
                                                                    onClick={(e) =>
                                                                        handleBankClick(e, {
                                                                            index: String(index),
                                                                            id: bank.id,
                                                                            qris: bank.image
                                                                        })
                                                                    }
                                                                    className="ms-3 custom-circular-checkbox-red"
                                                                    // Ensure the label text is clear for accessibility
                                                                    aria-label={`Select item ` + String(bank + 3)}
                                                                />
                                                            </span>
                                                            <div className="bank-photo-frame flex-center">
                                                                <img src={bank.logo} className="w-100" />
                                                            </div>
                                                            <span className="text-16 fw-bold" style={{ color: '#40494C' }}>
                                                                {bank.bankName}
                                                            </span>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                    );
                                })}
                            </Tab.Content>
                        </Tab.Container>
                        {/* <div className="bank-content">
                            {activeBank.map(
                                (bank, index) => (
                                    <label className="d-flex align-items-center gap-24 mb-32">
                                        <span className="position-relative">
                                            <Form.Check
                                                type="radio"
                                                id={`bankSelection-` + String(bank + 3)}
                                                // name="banks"
                                                {...register("bankTransferId")}
                                                value={bank.id}
                                                onClick={(e) => handleBankClick(e, { index: String(index), id: bank.id, qris: bank.image })}
                                                className="ms-3 custom-circular-checkbox-red"
                                                // Ensure the label text is clear for accessibility
                                                aria-label={`Select item ` + String(bank + 3)}
                                            />
                                        </span>
                                        <div className="bank-photo-frame flex-center" >
                                            <img src={bank.logo} className="w-100" />
                                        </div>
                                        <span className="text-16 fw-bold" style={{ color: "##40494C" }}>{bank.bankName}</span>
                                    </label>
                                )
                            )}
                        </div> */}
                    </div>

                    <div className="form-group mb-20">
                        <label className="form-label d-flex align-items-center gap-10">
                            <div className="position-relative">
                                <div
                                    className="position-absolute text-white"
                                    style={{ left: '5px', top: '50%', transform: 'translateY(-50%)' }}
                                >
                                    <i class="ph-bold ph-check"></i>
                                </div>
                                <input type="checkbox" className={inputcheckClass('agreement')} {...register('agreement')} />
                            </div>
                            <span className="fw-bold">
                                Agree to <span className="text-primary">Terms and Conditions</span>.
                                {/* I aggree with <span className="text-primary">Terms & Conditions</span>. */}
                            </span>
                        </label>
                    </div>

                    <div className="p-20 text_quicksand mb-40" style={{ backgroundColor: '#F1F1F1' }}>
                        By clicking 'Agree & Continue', I agree to the{' '}
                        <Link to="/membership-agreement" target="_blank">
                            Seller Membership Agreement
                        </Link>
                        ,
                        <Link to="/term-and-condition" target="_blank">
                            Terms of Use
                        </Link>
                        , and{' '}
                        <Link to="/payment-policy" target="_blank">
                            Privacy Policy
                        </Link>{' '}
                        of iWANT-ASIA.com.I agree to receive more information about the platform’s products and services.
                    </div>

                    <div className="d-flex justify-content-end">
                        {/* <button className="btn btn_mart_secondary" onClick={() => navigate("/registration-shop-information")}>Previous</button>
                        <button className="btn btn_mart_primary" onClick={() => navigate("/registration-seller-completed")}>Next</button> */}
                        {/* <button className="btn btn_mart_secondary" type="button" onClick={() => navigate("/registration-shop-information")}>Previous</button> */}
                        <button className="btn btn_mart_primary" type="submit" disabled={!agreementValue}>
                            Next
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CompanySellerSubsPayment_Summary;
